"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1044.796 -81.54)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1044.796 81.54)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1056.795,105.537a12,12,0,1,1,12-12A12.012,12.012,0,0,1,1056.795,105.537Zm0-23.037a11.039,11.039,0,1,0,11.039,11.039A11.051,11.051,0,0,0,1056.795,82.5Z",
    transform: "translate(-1044.796 -81.54)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1054.25 91.931)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1055.125,97.454a.48.48,0,0,1-.34-.82l4.13-4.129a.48.48,0,0,1,.679.679l-4.13,4.13A.482.482,0,0,1,1055.125,97.454Z",
    transform: "translate(-1054.645 -92.365)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1059.254,97.454a.478.478,0,0,1-.339-.14l-4.13-4.13a.48.48,0,0,1,.679-.679l4.13,4.129a.48.48,0,0,1-.34.82Z",
    transform: "translate(-1054.645 -92.365)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1050.298 86.886)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e80000 ",
    d: "M1057.025,101.9a.481.481,0,0,1-.167-.031c-5.853-2.167-6.329-6.521-6.329-11.568a.481.481,0,0,1,.355-.464c.043-.012,4.406-1.2,5.8-2.6a.506.506,0,0,1,.689,0c1.392,1.395,5.753,2.584,5.8,2.6a.48.48,0,0,1,.355.464c0,5.046-.476,9.4-6.328,11.568A.484.484,0,0,1,1057.025,101.9Zm-5.536-11.235c.022,4.773.526,8.315,5.536,10.242,5.01-1.927,5.514-5.469,5.536-10.242a19.247,19.247,0,0,1-5.536-2.446A19.273,19.273,0,0,1,1051.489,90.666Z",
    transform: "translate(-1050.528 -87.109)"
  })))));
};

exports["default"] = _default;